export const caseStudiesData = [
  {
    id: "01",
    title: "A Case of a Doctor Couple Bitten Severely by Their Pet Dog",
    info: ` Pets can transmit rabies, despite being vaccinated, mostly because
    the vaccination was ineffective due to a reason that is not known.
    This case describes the management of a doctor couple who were
    bitten by their vaccinated pet. The male was a known case of
    diabetes and hypertension, whereas the female doctor was bitten by
    a dog about six months ago. The couple was mainly managed by Anti
    Rabies Vaccine IM and Human Rabies Immunoglobulin (HRIG).`,
  },
  {
    id: "02",
    title: "A Case of an 18 Years Old Girl",
    info: ` Rabies post-exposure prophylaxis is given not only for dog bites
    but also for scratches and licks on broken skin. An 18-year-old
    girl was scratched by her 2-year-old pet dog near her neck region.
    The wounds were deep, which lead to profuse bleeding. After the
    basic steps of cleaning with water and soap, the case was managed
    by Human Rabies Immunoglobulin and intramuscular Anti Rabies
    Vaccine.`,
  },
  {
    id: "03",
    title: `A Case of 7 Years Old Girl Trying to Kiss an About 1-Year-Old Dog`,
    info: ` The wounds that are closer to the brain are more dangerous than
    others as the incubation period of vaccines becomes short; the
    children are at higher risk of having shorter incubation period. A
    7-year-old girl was bitten by her 1-year-old dog while trying to
    kiss her pet on the face. The dog bit the lower lip of the girl
    and caused bleeding. After cleaning the wound, some calculated
    dose of Human Rabies Immunoglobulin was infiltrated into &amp;
    around the wound, due to anatomical restrictions, and the
    remaining was injected through a deep intramuscular route.
    Anti-Rabies Vaccine was also given intramuscularly.`,
  },
  {
    id: "04",
    title: `A Case of Dog’s Saliva Fell into the Eye of an Adult`,
    info: ` Rabies can transmit when the bodily fluids of the animal come in
    contact with wounded region, broken skin or other organs like
    eyes. In a case, a dog’s saliva fell into the eye of an adult. The
    eye was washed with water; saline can also be used. The Human
    Rabies Immunoglobulin was instilled in the form of eye drops. This
    was followed by a full course of anti-rabies intramuscular
    vaccination.`,
  },
  {
    id: "05",
    title: `A Case of a Patient Who was Admitted in ICU`,
    info: ` A patient who was admitted in the ICU complained of paresis,
    in-coordination, change in mental status, and hyperactivity.
    Despite neurological and psychological interventions, the patient
    did not show any improvement in the condition. Upon collecting the
    detailed medical history, the patient revealed that he was bitten
    by a stray dog a month ago, and he did not seek any medical
    treatment for it. The patient was finally diagnosed as having Dumb
    (Paralytic) Rabies in its neurological stage. The patient died 4
    days later.`,
  },

  {
    id: "06",
    title: `A Case of Category 3 Cat Scratch`,
    info: ` Although most importance is given in treating dog bites and
    scratches, scratches by cats should not be ignored; they should be
    treated in a similar way. An adult male was scratched by a cat
    while trying to save a pigeon from the cat’s attack. The scratch
    was on the dorsal side of his right hand, which caused bleeding.
    The wound was classified as category 3. The wound was managed with
    Human Rabies Immunoglobulin and Anti-Rabies vaccination.`,
  },
  {
    id: "07",
    title: ` Case of a Child, 10 Years Old, Suffering from Jaundice`,
    info: ` There are several myths surrounding do’s and don’ts after a dog
    bite. Here we present a case where parents fell prey to a myth. A
    10-year-old child suffering from jaundice was bitten on left lower
    leg by a stray dog. The wound was classified as category 3 bite;
    however, whether the bite was provoked or unprovoked, it was not
    clear. Believing a myth, the parents bandaged the wound with red
    chilli powder, without even washing the wound. But washing the
    wound and rushing to the hospital and taking rabies vaccine should
    be encouraged.`,
  },
  {
    id: "08",
    title: ` A Case of Rabies Post-exposure Prophylaxis to one HIV Positive
    Patient`,
    info: ` A 42-year-old HIV positive male was bitten on the back side of his
    right leg. The wound was classified as category 3. The wound was
    washed thoroughly, and the patient was administered with Human
    Rabies Immunoglobulin. This was followed by Anti-Rabies
    Vaccination. Ten days after completing the vaccination course, the
    patient was referred to NCDC, Delhi for anti-rabies antibody
    estimation. Patient whose immunological memory is compromised,
    proper wound management, antisepsis, infiltration of rabies
    immunoglobulins and anti-rabies vaccination becomes extremely
    crucial.`,
  },
  {
    id: "09",
    title: `A Case of a Vaccinated Pet Dog had Bit a 9 Years Old Boy`,
    info: `Vaccination of animals does not assure 100% protection against
    rabies. Animal vaccines may fail due to improper administration,
    poor quality, or poor health status of the animal. Also, one
    vaccine dose may not always provide long-lasting protection in
    dogs. This case describes the management of a 9-year-old boy who
    was bitten by his vaccinated pet dog. As for any dog bite, post
    exposure treatment with Human Rabies Immunoglobulin and
    anti-rabies vaccination was opted.`,
  },
  {
    id: "10",
    title: `A Case of 48 Years Old Male Came with Category 3 Dog Bite Wound on
    Right Arm`,
    info: `A 48-year-old male had a category 3 dog bite on the right arm. The
    patient was previously bitten by an animal and was given full
    post-exposure Nerve Tissue Vaccine (NTV) in the year 2002. Such
    cases should be treated as fresh case. Thus, the patient was given
    Human Rabies Immunoglobulin and Anti-Rabies Vaccination.`,
  },
  {
    id: "11",
    title: `A Case of Stray Dog had Bitten a 23 Years Old Female`,
    info: `A 23-year-old female was bitten by a stray dog in a remote area of
    Himachal Pradesh, which left a category 3 wound. Such cases
    require Rabies Immunoglobulin, which was not available in that
    region. The patient was administered with a double dose of
    Anti-Rabies Vaccination and the healthcare providers were
    instructed to follow WHO-ESSEN-IM schedule. After this, a full
    course of vaccine was followed.`,
  },
  {
    id: "12",
    title: `A Case of a Sexually Active Female Whose Husband Died of Rabies`,
    info: `A female’s husband died with rabies, which was diagnosed by
    post-mortem. The female was given full calculated dose of Human
    Rabies Immunoglobulin and a full course of Anti-Rabies
    Vaccination, given intramuscularly. This was given to prevent
    infection of the rabies virus. If the virus is present in the
    semen or vaginal secretions, it can cause symptoms such as
    priapism, increased sexual libido and indulgence.`,
  },
  {
    id: "13",
    title: `A Case of Cow Infected with Rabies`,
    info: `During a Hindu festival, un-boiled milk is distributed as
    ‘prasad’. A case is discussed where such prasad was given in a
    village, and two cows whose milk was present in the prasad died
    due to rabies. Un-boiled milk of animals can contain rabies virus.
    This created a panic among he villagers. They were counselled
    about the condition. Those who were not satisfied with counselling
    were given Post Exposure Prophylaxis. However, Rabies
    Immunoglobulin was not given.`,
  },
  {
    id: "14",
    title: `A Case of 32 Years Old Bitten on Face, Neck and Left Upper Arm`,
    info: `A 32-year-old was bitten on the face, neck and left upper arm.
    These wounds were deep and required suturing. The attending
    surgeon cleaned and sutured the wounds and did the surgical
    dressing. But the dressing had to be cut, and Human Rabies
    Immunoglobulin had to be infiltrated. This was followed by
    Anti-Rabies Vaccine, which was given intramuscularly. Suturing of
    the bite increases the risk of inoculation of the virus deep into
    the wound. The wound should be suture after several hours to 3
    days after infiltration of Rabies Immunoglobulin.`,
  },
  {
    id: "15",
    title: `A Case of a 26 Years Old Male was Scratched on Left Thigh by a
    Stray Dog`,
    info: `A 26-year-old male was scratched on high left thigh by a stray
    dog. The scratches were classified as category 2, which did not
    require Rabies Immunoglobulin. However, Anti-Rabies vaccination
    was given. The patient wanted to observe the dog for any signs of
    rabies. The adult received two doses of modern vaccine; the dog
    received vaccine on days 5 and 7. However, the dog died on the
    10th day. The remaining three doses of vaccine was given to the
    patient and all five injections must be completed by day 28.`,
  },
  {
    id: "16",
    title: `A Case of 7 Years Old Boy was Bitten by a Stray Dog on the
    Genitals`,
    info: `A 7-year-old boy was bitten by a stray dog on the genitals. The
    local doctor cleaned the wounds with an antiseptic and prescribed
    one injection of Gentamicin and one injection of dexamethasone.
    However, the wound on the scrotum got infected. Proper wound
    toileting was done. Human Rabies Immunoglobulin (HRIG) was
    infiltrated in bite wounds. This was followed by Anti-Rabies
    Vaccination.`,
  },
  {
    id: "17",
    title: `A Case of Monkey Bite and Scratches`,
    info: `A 24-year-old was bitten by a monkey and a 52-year-old was
    scratched on the face by a monkey. The wounds were classified as
    category 3. Both patients were given Human Rabies Immunoglobulin
    and Anti-Rabies vaccination.`,
  },
  {
    id: "18",
    title: ` A Case of Case of Category 3 Dog Bite`,
    info: `A 34-year-old courier man was bitten by a dog in right lower leg.
    A local doctor oozed the wound to remove the poisonous’ blood,
    thereby deepening the wound. He also bandaged the wound. The
    bandage had to be removed and the wound had to be cleaned with
    soap and water. The courier man was then given Human Rabies
    Immunoglobulin and Anti-Rabies Vaccination.`,
  },
  {
    id: "19",
    title: ` A Case of a Morning Walker`,
    info: `A 28-years-old lady had gone for a morning walk to a ridge area.
    She was attacked by a monkey, which scratched on her hand and
    face. The wounds were deep and were classified as category 3.
    Human Rabies Immunoglobulin (HRIG) was infiltrated and Anti-rabies
    vaccination was started.`,
  },
];
export const clinicalTrialsData = [
  {
    title: "Clinical Trials Studies Page 1 & 2",
    path: "/pdf/page-1-2.pdf",
  },
  {
    title: "Clinical Trials Studies Page 3 & 4",
    path: "/pdf/page-3-4.pdf",
  },
  {
    title: "Clinical Trials Studies Page 5 & 6",
    path: "/pdf/page-5-6.pdf",
  },
  {
    title: "Clinical Trials Studies Page 7 & 8",
    path: "/pdf/page-7-8.pdf",
  },
  {
    title: "Clinical Trials Studies Page 9 & 10",
    path: "/pdf/page-9-10.pdf",
  },
  {
    title: "Clinical Trials Studies Page 11 & 12",
    path: "/pdf/page-11-12.pdf",
  },
  {
    title: "Clinical Trials Studies Page 13 & 14",
    path: "/pdf/page-13-14.pdf",
  },
  {
    title: "Clinical Trials Studies Page 15 & 16",
    path: "/pdf/page-15-16.pdf",
  },
  {
    title: "Clinical Trials Studies Page 17 & 18",
    path: "/pdf/page-17-18.pdf",
  },
  {
    title: "Clinical Trials Studies Page 19 & 20",
    path: "/pdf/page-19-20.pdf",
  },
  {
    title: "Clinical Trials Studies Page 21",
    path: "/pdf/page-21.pdf",
  },
];

export const resources = [
  {
    title: "Abhayrab_full-Report_Vietnam",
    path: "/pdf/publications/Abhayrab_full-Report_Vietnam.pdf",
  },
  {
    title: "APCRI Journal publication 2018 PDF",
    path: "/pdf/publications/APCRI-Journal-publication-2018.pdf",
  },
  {
    title: "APCRI-2000",
    path: "/pdf/publications/APCRI-2000.pdf",
  },
  {
    title: "Article-Abhayrab-Philippines",
    path: "/pdf/publications/Article-Abhayrab-Philippines.pdf",
  },
  {
    title: "Fox Bite-Abhayrab",
    path: "/pdf/publications/Fox-Bite-Abhayrab.pdf",
  },
  {
    title: "ICMR",
    path: "/pdf/publications/ICMR.pdf",
  },
  {
    title: "Interchangeability of Rabies Vaccines in Humans",
    path: "/pdf/publications/interchangeability-of-rabies-vaccines-in-humans.pdf",
  },
  {
    title: "Intradermal PEP Dr Ravish",
    path: "/pdf/publications/Intradermal-PEP-Dr-Ravish.pdf",
  },
  {
    title: "IOSR-IM-ID",
    path: "/pdf/publications/IOSR-IM-ID.pdf",
  },
  {
    title: "Pregnant women vaccination",
    path: "/pdf/publications/Pregnant-women-vaccination.pdf",
  },
  {
    title: "Published Article-Burla",
    path: "/pdf/publications/Published-Article-Burla.pdf",
  },
  {
    title: "Vaccine-Elsevier",
    path: "/pdf/publications/Vaccine-Elsevier.pdf",
  },
  {
    title: "Zagreb regimen- Turkey",
    path: "/pdf/publications/Zagreb-regimen-Turkey.pdf",
  },
];
